// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--HfzGW","wrapper":"a10a3f92e9--wrapper--xyaQb","title":"a10a3f92e9--title--9dsfx"};